(function () {
  'use strict';

  var instances = new WeakMap();
  var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function reducedMotion() { return motionQuery && motionQuery.matches; }
  function finePointer() { return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches; }
  function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }

  function init(section) {
    if (!section || instances.has(section)) return;

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-approach-card]'));
    var cleanups = [];
    var frame = 0;
    var reduced = reducedMotion();
    var desktopPointer = !reduced && finePointer();
    var mobileScroll = !reduced && !desktopPointer;

    if (!reduced) section.classList.add('is-enhanced');

    if (window.IntersectionObserver && !reduced) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-visible');
        });
      }, { threshold: 0.14 });
      cards.forEach(function (card) { revealObserver.observe(card); });
      cleanups.push(function () { revealObserver.disconnect(); });
    } else {
      cards.forEach(function (card) { card.classList.add('is-visible'); });
    }

    var visual = section.querySelector('[data-approach-visual]');
    function resetDepth() {
      cards.forEach(function (card) {
        var pointer = card.querySelector('.approach-cta__card-pointer');
        if (!pointer) return;
        pointer.style.setProperty('--approach-rotate-x', '0deg');
        pointer.style.setProperty('--approach-rotate-y', '0deg');
        pointer.style.setProperty('--approach-x', '0px');
        pointer.style.setProperty('--approach-y', '0px');
      });
    }

    if (desktopPointer && visual) {
      var pointerMove = function (event) {
        var bounds = visual.getBoundingClientRect();
        var x = (event.clientX - bounds.left) / bounds.width - 0.5;
        var y = (event.clientY - bounds.top) / bounds.height - 0.5;
        cards.forEach(function (card, index) {
          var pointer = card.querySelector('.approach-cta__card-pointer');
          var depth = [0.75, 1, 1.15][index] || 1;
          if (!pointer) return;
          pointer.style.setProperty('--approach-rotate-y', (x * 4 * depth).toFixed(2) + 'deg');
          pointer.style.setProperty('--approach-rotate-x', (-y * 4 * depth).toFixed(2) + 'deg');
          pointer.style.setProperty('--approach-x', (x * 12 * depth).toFixed(1) + 'px');
          pointer.style.setProperty('--approach-y', (y * 12 * depth).toFixed(1) + 'px');
        });
      };
      visual.addEventListener('pointermove', pointerMove, { passive: true });
      visual.addEventListener('pointerleave', resetDepth);
      cleanups.push(function () {
        visual.removeEventListener('pointermove', pointerMove);
        visual.removeEventListener('pointerleave', resetDepth);
      });
    }

    function updateMobileScroll() {
      frame = 0;
      if (!mobileScroll) return;
      var viewportCentre = window.innerHeight / 2;
      cards.forEach(function (card, index) {
        var pointer = card.querySelector('.approach-cta__card-pointer');
        if (!pointer) return;
        var bounds = card.getBoundingClientRect();
        var distance = clamp((bounds.top + bounds.height / 2 - viewportCentre) / (window.innerHeight * 0.8), -1, 1);
        var depth = [0.75, 1, 1.15][index] || 1;
        pointer.style.setProperty('--approach-y', (-distance * 8 * depth).toFixed(1) + 'px');
        pointer.style.setProperty('--approach-rotate-x', '0deg');
        pointer.style.setProperty('--approach-rotate-y', (distance * 1.4 * depth).toFixed(2) + 'deg');
      });
    }

    function requestMobileScroll() {
      if (!frame) frame = window.requestAnimationFrame(updateMobileScroll);
    }

    if (mobileScroll) {
      updateMobileScroll();
      window.addEventListener('scroll', requestMobileScroll, { passive: true });
      window.addEventListener('resize', requestMobileScroll);
      cleanups.push(function () {
        if (frame) window.cancelAnimationFrame(frame);
        window.removeEventListener('scroll', requestMobileScroll);
        window.removeEventListener('resize', requestMobileScroll);
        resetDepth();
      });
    }

    var activeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { section.classList.toggle('is-active', entry.isIntersecting); });
    }, { rootMargin: '150px 0px' });
    activeObserver.observe(section);
    cleanups.push(function () { activeObserver.disconnect(); section.classList.remove('is-active'); });

    var cleanup = function () {
      cleanups.forEach(function (remove) { remove(); });
      section.classList.remove('is-enhanced');
      instances.delete(section);
    };
    instances.set(section, cleanup);
  }

  function destroy(root) {
    var section = root && root.matches && root.matches('[data-approach-cta]') ? root : root && root.querySelector('[data-approach-cta]');
    var cleanup = section && instances.get(section);
    if (cleanup) cleanup();
  }

  function initAll(root) { (root || document).querySelectorAll('[data-approach-cta]').forEach(init); }
  function motionChanged() { document.querySelectorAll('[data-approach-cta]').forEach(function (section) { var cleanup = instances.get(section); if (cleanup) cleanup(); init(section); }); }

  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
  document.addEventListener('shopify:section:reorder', function () { initAll(); });
  if (motionQuery) {
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', motionChanged);
    else if (motionQuery.addListener) motionQuery.addListener(motionChanged);
  }
}());
